export const APP_ENVIRONMENT_NAMES = ['local', 'dev', 'staging', 'production'] as const;

export type AppEnvironmentName = (typeof APP_ENVIRONMENT_NAMES)[number];

export interface IAppEnvironmentColors {
  localColor: string;
  devColor: string;
  stgColor: string;
}

export interface IHeaderEnvironmentAppearance {
  label: string;
  backgroundColor: string | null;
}

export interface IAppEnvironmentColorInput {
  localColor?: string;
  devColor?: string;
  stgColor?: string;
}

export const DEFAULT_APP_ENVIRONMENT_COLORS: IAppEnvironmentColors = {
  localColor: '#e0f2fe',
  devColor: '#fef3c7',
  stgColor: '#FFFFFF',
};

const HEADER_LABEL: Record<AppEnvironmentName, string> = {
  local: 'LOCAL',
  dev: 'DEV',
  staging: 'PROD',
  production: '',
};

const APP_ENVIRONMENT_ALIASES: Record<string, AppEnvironmentName> = {
  local: 'local',
  dev: 'dev',
  staging: 'staging',
  stg: 'staging',
  production: 'production',
  prod: 'production',
};

export function resolveAppEnvironment(
  raw: string | undefined,
  fallback: AppEnvironmentName
): AppEnvironmentName {
  const value = raw?.trim().toLowerCase();
  if (!value) return fallback;
  return APP_ENVIRONMENT_ALIASES[value] ?? fallback;
}

function resolveEnvColor(value: string | undefined, fallback: string): string {
  const trimmed = value?.trim();
  return trimmed ? trimmed : fallback;
}

export function resolveEnvColors(input: IAppEnvironmentColorInput = {}): IAppEnvironmentColors {
  return {
    localColor: resolveEnvColor(input.localColor, DEFAULT_APP_ENVIRONMENT_COLORS.localColor),
    devColor: resolveEnvColor(input.devColor, DEFAULT_APP_ENVIRONMENT_COLORS.devColor),
    stgColor: resolveEnvColor(input.stgColor, DEFAULT_APP_ENVIRONMENT_COLORS.stgColor),
  };
}

export function resolveHeaderAppearance(
  appEnv: AppEnvironmentName,
  colors: IAppEnvironmentColors
): IHeaderEnvironmentAppearance {
  const colorByEnv: Record<AppEnvironmentName, string | null> = {
    local: colors.localColor,
    dev: colors.devColor,
    staging: colors.stgColor,
    production: null,
  };

  return {
    label: HEADER_LABEL[appEnv],
    backgroundColor: colorByEnv[appEnv],
  };
}
